export const APP_INSIGHTS_INTRUMENTATION_KEY_DEV = '';

export const UNDERSTANDING_DYSLEXIA_API_PATH = 'https://ud-api-dev.nessy.com/';

export const UNDERSTANDING_DYSLEXIA_ASSET_PATH ='https://cdn2.nessy.com/nessy-cms';
